import React from 'react';

const AddComment = () => {
  return <div>AddComment</div>;
};

export default AddComment;
